export const DATASET_ID_JOURNAL_METADATA = "journalmetadata";
export const DATASET_ID_JOURNAL_ARTICLES = "journalArticles";
export const DATASET_ID_BOOKS = "jbn";
export const DATASET_ID_NEWSPAPERS = "newspaperpdfs";
export const DATASET_ID_PROCUREMENT = "procurement";
export const DATASET_ID_ENTITIES = "rover";
export const DATASET_ID_RESUMES = "resumes";
export const DATASET_ID_AWARDS = "contract_awards";
export const DATASET_ID_CORP_RECORDS = "corprecords";
export const DATASET_ID_CORP_RECORDS_TYC_PROFILE = "corprecords_tyc_profile";
export const DATASET_ID_CORP_RECORDS_TYC_SHARE = "corprecords_tyc_shareholder";
export const DATASET_ID_CORP_RECORDS_TYC_INVEST = "corprecords_tyc_investment";
export const DATASET_ID_CORP_RECORDS_RASMIO_DOCS = "corprecords_rasmio_documents";
export const DATASET_ID_CORP_RECORDS_RASMIO_RECS = "corprecords_rasmio_records";
export const DATASET_ID_CORP_RECORDS_RASMIO_PEOPLE = "corprecords_rasmio_people";
export const DATASET_ID_CCP_LEAK = "profiledata_2016";
export const DATASET_ID_REFERENCES= "references";
export const DATASET_ID_AEROSPACE= "aerospace";
export const DATASET_ID_GREENPARROT= "greenparrot";
export const DATASET_ID_IRAN_OIL_SANCTION_VIOLATIONS = "iran_oil_sanction_violations";
export const DATASET_ID_UNIVERSAL = "ALL";

// Non Data Explorer, here for convenience
export const DATASET_ID_SOCIAL_MEDIA = "social_media";
export const DATASET_ID_MEDIA = "media";
export const DATASET_ID_NARRATIVES = "narratives";
export const DATASET_ID_WEB = "web_pages";
export const DATASET_ID_VIDEO = "video";
export const DATASET_ID_CURATED = "curated";

export const DATASET_TITLES = {
	[DATASET_ID_JOURNAL_METADATA]: "Journal Metadata",
	[DATASET_ID_JOURNAL_ARTICLES]: "Journal Articles",
	[DATASET_ID_BOOKS]: "Books",
	[DATASET_ID_NEWSPAPERS]: "Newspapers",
	[DATASET_ID_PROCUREMENT]: "Procurement Data",
	[DATASET_ID_ENTITIES]: "Entities",
	[DATASET_ID_RESUMES]: "Resumes",
	[DATASET_ID_AWARDS]: "Russia Contracts",
	[DATASET_ID_CORP_RECORDS]: "Corporate Registration Data",
	[DATASET_ID_CORP_RECORDS_TYC_PROFILE]: "China Company Records",
	[DATASET_ID_CORP_RECORDS_TYC_SHARE]: "China Shareholder Records",
	[DATASET_ID_CORP_RECORDS_TYC_INVEST]: "China Investment Records",
	[DATASET_ID_CORP_RECORDS_RASMIO_DOCS]: "Iran Corporate Docs",
	[DATASET_ID_CORP_RECORDS_RASMIO_RECS]: "Iran Corporate Recs",
	[DATASET_ID_CORP_RECORDS_RASMIO_PEOPLE]: "Iran Corporate People",
	[DATASET_ID_CCP_LEAK]: "CCP Members Leak",
	[DATASET_ID_REFERENCES]: "References",
	[DATASET_ID_AEROSPACE]: "Aerospace",
	[DATASET_ID_GREENPARROT]: "GreenParrot",
	[DATASET_ID_IRAN_OIL_SANCTION_VIOLATIONS]: "Iran Oil/Sanctions Email Leak",

	// Non Data Explorer, here for convenience
	[DATASET_ID_SOCIAL_MEDIA]: "Social Media",
	[DATASET_ID_MEDIA]: "Media",
	[DATASET_ID_NARRATIVES]: "Narratives",
	[DATASET_ID_WEB]: "Web Pages",
};

export const DATASET_PATHS = [
	{ id: DATASET_ID_JOURNAL_METADATA, path: "journalmetadata" },
	{ id: DATASET_ID_JOURNAL_ARTICLES, path: "journalarticles" },
	{ id: DATASET_ID_BOOKS, path: "books" },
	{ id: DATASET_ID_NEWSPAPERS, path: "newspapers" },
	{ id: DATASET_ID_PROCUREMENT, path: "procurement" },
	{ id: DATASET_ID_ENTITIES, path: "entities" },
	{ id: DATASET_ID_RESUMES, path: "resumes" },
	{ id: DATASET_ID_AWARDS, path: "contractawards" },
	{ id: DATASET_ID_CORP_RECORDS, path: "corprecords" },
	{ id: DATASET_ID_CORP_RECORDS_TYC_PROFILE, path: "chinacomprecords" },
	{ id: DATASET_ID_CORP_RECORDS_TYC_SHARE, path: "chinasharerecords" },
	{ id: DATASET_ID_CORP_RECORDS_TYC_INVEST, path: "chinainvestrecords" },
	{ id: DATASET_ID_CORP_RECORDS_RASMIO_DOCS, path: "irancorpdocs" },
	{ id: DATASET_ID_CORP_RECORDS_RASMIO_RECS, path: "irancorprecords" },
	{ id: DATASET_ID_CORP_RECORDS_RASMIO_PEOPLE, path: "irancorppeople" },
	{ id: DATASET_ID_CCP_LEAK, path: "profiledata_2016" },
	{ id: DATASET_ID_REFERENCES, path: "references" },
	{ id: DATASET_ID_AEROSPACE, path: "aerospace" },
	{ id: DATASET_ID_GREENPARROT, path: "greenparrot" },
	{ id: DATASET_ID_IRAN_OIL_SANCTION_VIOLATIONS, path: "iranoilsanctions" },
];

export const DATASET_PROPS = {
	[DATASET_ID_JOURNAL_METADATA]: { timeControls: false },
	[DATASET_ID_JOURNAL_ARTICLES]: { timeControls: false },
	[DATASET_ID_BOOKS]: { timeControls: false },
	[DATASET_ID_NEWSPAPERS]: { timeControls: false },
	[DATASET_ID_PROCUREMENT]: { timeControls: false },
	[DATASET_ID_ENTITIES]: { timeControls: false },
	[DATASET_ID_RESUMES]: { timeControls: false },
	[DATASET_ID_AWARDS]: { timeControls: false },
	[DATASET_ID_CORP_RECORDS]: { timeControls: false },
	[DATASET_ID_CORP_RECORDS_TYC_PROFILE]: { timeControls: false },
	[DATASET_ID_CORP_RECORDS_TYC_SHARE]: { timeControls: false },
	[DATASET_ID_CORP_RECORDS_TYC_INVEST]: { timeControls: false },
	[DATASET_ID_CORP_RECORDS_RASMIO_DOCS]: { timeControls: false },
	[DATASET_ID_CORP_RECORDS_RASMIO_RECS]: { timeControls: false },
	[DATASET_ID_CORP_RECORDS_RASMIO_PEOPLE]: { timeControls: false },
	[DATASET_ID_CCP_LEAK]: { timeControls: false },
	[DATASET_ID_REFERENCES]: { timeControls: false },
	[DATASET_ID_AEROSPACE]: { timeControls: false },
	[DATASET_ID_GREENPARROT]: { timeControls: false },
	[DATASET_ID_IRAN_OIL_SANCTION_VIOLATIONS]: { timeControls: false },
};

export const getDefaultDatasetSortType = (datasetID) => {
	switch (datasetID) {
		case DATASET_ID_CCP_LEAK:
			return "name";
		default:
			return "relevancy";
	}
};

export const getDefaultDatasetSortAsc = (datasetID) => {
	switch (datasetID) {
		default:
			return false;
	}
};

export const datasetUsesPdfModal = (datasetId) => {
	return [
		DATASET_ID_BOOKS, 
		DATASET_ID_NEWSPAPERS, 
		DATASET_ID_JOURNAL_ARTICLES,
		DATASET_ID_REFERENCES,
		DATASET_ID_AEROSPACE,
		DATASET_ID_GREENPARROT,
	].includes(datasetId);
};

export const datasetSupportsMultiDocChat = (datasetId) => {
	return [
		DATASET_ID_JOURNAL_METADATA,
		DATASET_ID_JOURNAL_ARTICLES, 
		DATASET_ID_PROCUREMENT, 
		DATASET_ID_AEROSPACE,
		DATASET_ID_GREENPARROT,
		DATASET_ID_IRAN_OIL_SANCTION_VIOLATIONS,
	].includes(datasetId);
};

export const datasetUsesEntityDisplay = (datasetId) => {
	return [
		DATASET_ID_ENTITIES,
		DATASET_ID_CORP_RECORDS,
		DATASET_ID_RESUMES,
	].includes(datasetId);
};